import {
  CATEGORIES_FRAGMENT,
  EVENT_LABEL_CATEGORY_FRAGMENT,
  PROGRAM_CATEGORY_FRAGMENT,
  VENUE_CATEGORY_FRAGMENT,
} from '@/gql/fragments/categories.gql';
import { createFragmentParser } from '@liquorice/gql-utils';
import { MaybeFragment } from '@liquorice/gql-utils/src/getMaybeFragmentData';
import { firstNonNullable } from '@liquorice/utils';
import {
  CategoriesFragment,
  ProgramCategoryFragment,
  VenueCategoryFragment,
} from '@/__generated__/graphql';

export const parseCategoriesFragment = createFragmentParser(CATEGORIES_FRAGMENT, (data) => data);

export const parseVenueCategory = createFragmentParser(VENUE_CATEGORY_FRAGMENT, (data) => data);

export const parseProgramCategory = createFragmentParser(PROGRAM_CATEGORY_FRAGMENT, (data) => data);

export const parseEventLabelCategory = createFragmentParser(
  EVENT_LABEL_CATEGORY_FRAGMENT,
  (data) => data
);

export const parseVenue = (
  maybeFragment: MaybeFragment<CategoriesFragment>[]
): VenueCategoryFragment | undefined => {
  const fragment = firstNonNullable(maybeFragment);

  const category = parseCategoriesFragment(fragment);

  if (category?.__typename === 'venueCategory_Category') {
    return parseVenueCategory(category) ?? undefined;
  }

  return undefined;
};

export const parseProgram = (
  maybeFragment: MaybeFragment<CategoriesFragment>[]
): ProgramCategoryFragment | undefined => {
  const fragment = firstNonNullable(maybeFragment);

  const category = parseCategoriesFragment(fragment);

  return parseProgramCategory(category as MaybeFragment<ProgramCategoryFragment>) ?? undefined;
};

// export const createCategory = <TFragment, TResult>(
//   fragment: TypedDocumentNode<TFragment>,
//   parser: (data: TFragment) => TResult | undefined
// ): ((maybeData: MaybeFragment<TFragment>[]) => TResult | undefined) => {
//   return function parseCategory(maybeData: MaybeFragment<TFragment>[]): TResult | undefined {
//     const first = firstNonNullable(maybeData);
//     if (!first) return undefined;

//     const data = getFragmentData(fragment, first as FragmentType<typeof fragment>);

//     if (!data) return undefined;

//     return parser(data);
//   };
// };
